var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import "react-dates/initialize";
import { Controller } from "react-hook-form";
import TaskService from "../../../Services/Task.service";
import TaskForm from "./TaskForm";
import DeprecatedSelect from "../../UI/DeprecatedSelect/DeprecatedSelect";
import useUniqueId from "../../Hooks/useUniqueId";
const TaskEditForm = (_a) => {
    var { taskIsPrivate } = _a, taskFormProps = __rest(_a, ["taskIsPrivate"]);
    const isPrivate = taskFormProps.watch("isPrivate");
    const makeId = useUniqueId()[1];
    React.useEffect(() => {
        if (isPrivate && taskIsPrivate) {
            taskFormProps.setValue("peopleToNotify", []);
        }
    }, [isPrivate, taskFormProps, taskIsPrivate]);
    return (_jsxs(_Fragment, { children: [_jsx(TaskForm, Object.assign({}, taskFormProps)), _jsx("hr", {}), _jsxs("div", { className: "form-group", title: isPrivate && taskIsPrivate
                    ? "Notifications about private tasks can only be sent when marking a public task as private or a private task as public."
                    : "", children: [_jsx("label", { htmlFor: makeId("peopleToNotify"), children: "People to notify about this change" }), _jsx(Controller, { name: "peopleToNotify", control: taskFormProps.control, as: _jsx(DeprecatedSelect.Async, { "aria-label": "People to notify about this change", id: makeId("peopleToNotify"), loadOptions: (query) => TaskService.searchPeopleThatCanAccessTasks(query).then((options) => ({
                                options,
                            })), disabled: isPrivate && taskIsPrivate, multi: true, valueKey: "personId", labelKey: "fullName", optionRenderer: (option) => {
                                return (_jsxs("div", { className: "d-flex", children: [_jsx("div", { className: "mr-1", children: option.fullName }), _jsx("div", { className: "text-muted", children: "(" + option.studentId + ")" })] }));
                            } }) })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("comment"), children: "Comment" }), _jsx("textarea", { id: makeId("comment"), rows: 2, className: "form-control", name: "comment", ref: taskFormProps.register })] })] }));
};
export default TaskEditForm;
